<div *ngIf="upperTitle"
     class="section__upper-title">
    {{ upperTitle | translate }}
</div>

<div *ngIf="!dropdown"
     [ngClass]="{
        'container': containerClass,
        'container--preview-mode': containerInPreviewMode
        }"
     class="section {{customClass}}">

        <div *ngIf="title"
             class="section__header">
            <div class="section__title container__title">
                <span class="section__title__text">
                    {{ title }}
                </span>
                <div *ngIf="description"
                     class="desc-icon">
                    <div class="tooltip" [attr.title]="description|translate">
                        <div class="icon-info_inactive tooltip__icon material-icons">
                            help
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="verifyDataVisible"
                 class="section__verify-data">
                <span class="section__verify-data__label">
                    {{ 'SECTION.VERIFY_DATA.label' | translate }}
                </span>
                <app-information-icon class="section__verify-data__icon information-icon"
                                      [tippyProps]="verifyDataTippyProps"
                                      [tooltipCssClass]="'verify-data-tooltip'"
                                      [information]="'SECTION.VERIFY_DATA.tooltip' | translate">
                </app-information-icon>
            </div>
        </div>

    <ng-template *ngTemplateOutlet="content"></ng-template>
</div>

<div *ngIf="dropdown">
    <mat-accordion class="dropdown-container">

        <mat-expansion-panel class="dropdown-container__content"
                             [ngClass]="{'dropdown-container__content--visible': disableOverflow}"
                             hideToggle
                             [disabled]="disabled"
                             [expanded]="expanded"
                             (afterExpand)="panelExpand()"
                             (closed)="panelClose()"
                             (opened)="panelOpened()">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div *ngIf="title" class="dropdown-container__title dropdown-container__tooltip">
                        <span>{{ title}}</span>
                    </div>
                    <div class="dropdown-container__tooltip">
                        <div *ngIf="description" class="dropdown-container__tooltip tooltip"
                             [attr.title]="description|translate">
                            <div class="icon-info_inactive tooltip__icon material-icons">
                                help
                            </div>
                        </div>
                    </div>
                </mat-panel-title>

                <div class="panel-actions" (click)="toggleExpanded()">
                    <div class="panel-actions__text"> {{ (!panelToggleState ? 'expand': 'collapse') | translate }}</div>
                    <mat-icon class="panel-actions__icon">{{ !panelToggleState ? 'expand_more': 'expand_less'}}
                    </mat-icon>
                </div>

            </mat-expansion-panel-header>

            <ng-template *ngTemplateOutlet="content"></ng-template>
        </mat-expansion-panel>

    </mat-accordion>
</div>

<ng-template #content>
    <form *ngIf="formGroup" [formGroup]="formGroup" class="form">
        <ng-container *ngTemplateOutlet="dynamicTemplate"></ng-container>
    </form>

    <ng-template #dynamicTemplate *ngTemplateOutlet="sectionRef"></ng-template>
</ng-template>

